<template>
    <transition name="fade">
        <div class="modal is-active" v-show="visible">
            <div class="modal-background" @click="destroy"></div>
            <div class="modal-content">
                <div class="popup-dialog">
                    <div class="popup-title">
                        <h1 class="title is-1">
                            {{ $t('digital.delivery_selection_form.title') }}
                        </h1>

                        <div class="popup-close" @click.prevent="destroy">
                            <i class="icon">close</i>
                        </div>
                    </div>

                    <div class="popup-body">
                        <div class="popup-buttons">
                            <button @click.prevent="selected = 'mail'" :class="{ 'active': selected === 'mail' }">
                                <img src="../../../../../images/icons/plane.svg" alt="Send through e-mail" width="43" height="28">
                                <p>{{ $t('digital.delivery_selection_form.button_mail') }}</p>
                            </button>

                            <button @click.prevent="selected = 'shipment'" :class="{ 'active': selected === 'shipment' }">
                                <img src="../../../../../images/icons/truck.svg" alt="Send through delivery" width="43" height="30">
                                <p>{{ $t('digital.delivery_selection_form.button_shipment') }}</p>
                            </button>
                        </div>

                        <div class="d-flex has-text-centered">
                            <div class="notification is-warning py-3 px-4 is-inline-block" v-if="order.has_been_sent_postage === true">
                                {{ $t('digital.delivery_selection_form.postage_enroute') }}
                            </div>
                        </div>
                    </div>

                    <div class="popup-footer">
                        <a @click.prevent="destroy" href="#" class="mr-3" role="button">{{ this.$t('digital.delivery_selection_form.cancel') }}</a>
                        <g-button :disabled="selected === null" @click.prevent="action">{{ this.$t('digital.delivery_selection_form.submit') }}</g-button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'DigitalOrderDeliverySelection',

    props: {
        order: {
            type: Object,
            required: true
        },
        shipmentPrices: {
            type: Object,
            required: true
        },
        mailTemplate: {
            type: Object,
            required: false,
        },
    },

    data () {
        return {
            selected: null
        }
    },

    methods: {
        action () {
            switch (this.selected) {
                case 'mail':
                    this.mail()
                    break

                case 'shipment':
                    this.shipment()
                    break

                default:
                    this.destroy()
            }
        },

        shipment () {
            this.destroy()

            setTimeout(() => {
                this.$popup('DigitalOrderShipment', {
                    order: this.order,
                    shipmentPrices: this.shipmentPrices
                })
            }, 150)
        },

        mail () {
            this.destroy()

            setTimeout(() => {
                if (this.order.has_been_sent_email === true) {
                    this.$popup('PromotionalDeliveryLogForm', {
                        order_id: this.order.id,
                    })

                    return;
                }

                this.$popup('DigitalOrderEmail', {
                    order: this.order,
                    mailTemplate: this.mailTemplate,
                })
            }, 150)
        }
    }
}
</script>
